export const DEFAULT_RESULTS_LIMIT = 20;
export const MAX_SUGGESTIONS_SIZE = 20;

export const FULL_TEXT_SEARCH_SUGGESTION_MINIMAL_LENGTH = 3;
